import React from 'react'
import {ReviewAuthor} from './ReviewAuthor'
import {ReviewStars} from './ReviewStars'
import {ReviewItem} from './types'

type Props = {
    item: ReviewItem
    reviewsUrl?: string
}

const ReviewCardList = ({item, reviewsUrl}: Props) => (
    <div className="card card-flush h-100 border">
        <div className="card-body">
            <div className="d-flex flex-stack flex-wrap gap-4">
                <ReviewAuthor authorName={item.author_name} reviewDate={item.review_date} />
                <div className="d-flex align-items-center">
                    <div className="text-center">
                        {reviewsUrl ? (
                            <a
                                href={reviewsUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-flex btn-light-primary btn-active-primary"
                            >
                                Repondre
                            </a>
                        ) : (
                            <button type="button" className="btn btn-sm btn-flex btn-light-primary btn-active-primary" disabled>
                                Repondre
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="d-flex flex-stack flex-wrap gap-4 my-5">
                <ReviewStars rating={Number(item.rating)} wrapperClassName="rating me-3 d-flex align-items-center gap-1" />
            </div>
            <div className="text-gray-700 fw-semibold fs-6">{item.comment}</div>
        </div>
    </div>
)

export {ReviewCardList}
